import { View } from 'backbone.marionette';
import { User } from '../../../models';
import { ErrorsModal, FileUtility } from '../../../utils';
import Preloader from '../../../utils/Preloader';
import Radio from 'backbone.radio';
import _ from 'lodash';

const fileChannel   = Radio.channel( 'file' );
const headerChannel = Radio.channel( 'header' );
const fileUtility   = new FileUtility();

export default class CoreAccountSettingsView extends View {
	get template() {
		throw new Error( "Need set template for child CoreAccountSettings class" );
	}

	get team_name_key() {
		return 'team_name';
	}


	/**
	 * Create events for this UI
	 * @returns object
	 */
	ui() {
		return {
			update_form:      '.js-update-user-form',
			update_team_form: '.js-update-team-form',
			team_name:        '.js-team-name',
			user_avatar:      '.js-user-avatar',
			display_img:      '.js-display-img',
			display_name:     '.js-display-team-name'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.update_team_form': 'checkForm',
			'change @ui.update_form':     'updateForm',
			'change @ui.user_avatar':     'updateAvatar'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'user:update:errors':       'updateUserError',
			'user:update:success':      'updateUserSuccess',
			'user:update:form:errors':  'checkUserFormErrors',
			'user:update:form:success': 'updateUserData'
		};
	}

	/**
	 * Initialize view data
	 */
	initialize() {
		this.model = User;
		this.model.set( 'errors', {} )
			.setUserAvatar();

		this.listenTo( fileChannel, 'file:parse', this.setDisplayImg );
	}

	updateAvatar( element ) {
		const file = $( element.currentTarget ).get( 0 ).files[ 0 ];
		fileUtility.parse( file );

		this.model.set( 'avatar', fileUtility.file );
	}

	setDisplayImg( img_base64 ) {
		this.getUI( 'display_img' ).attr( 'srcset', img_base64 );
	}

	updateUserError( errors ) {
		Preloader.hide();
		ErrorsModal.show( errors );
	}

	updateUserSuccess() {
		let avatar_version = this.model.get( 'avatar_version' ) + 1;
		this.model.set( 'avatar_version', avatar_version );

		headerChannel.trigger( 'header:update' );
		alert( 'Profile updated.' );
	}

	checkUserFormErrors( errors ) {
		_.each( errors, ( item, name ) => {
			$( '.' + name ).text( item[ 0 ] ).show();
		} );
	}

	updateUserData() {
		let data = {
			[this.team_name_key]: this.model.get(this.team_name_key),
			avatar:   this.model.get( 'avatar' )
		};

		this.model.updateUserData( data );
		return this;
	}

	updateForm() {
		this.clearFormError();

		let team_name = this.getUI( 'team_name' ).val();
		this.getUI( 'display_name' ).text( team_name );

		return this;
	}

	clearFormError() {
		this.getUI( 'update_form' )
			.find( '.error-message' )
			.hide();

		return this;
	}

	checkForm() {
		let team_name = this.getUI( 'team_name' ).val();

		this.model.set( {
			[this.team_name_key]: team_name
		} ).validateForm();

		return this;
	}

}